import React, { useState, useEffect } from 'react';
import './CSS/LandingPage.css';
import Logo from '../Components/Assets/RubyandRed_Logo_V1.png';
import product1 from '../Components/Assets/product-chair.png';
import product2 from '../Components/Assets/product-table.png';
import product3 from '../Components/Assets/product-chair.png'; 
import product4 from '../Components/Assets/product-table.png';
import product5 from '../Components/Assets/product-chair.png';  
import ExploreContent from '../Components/ExploreContent/ExploreContent';
import HomeVideo from '../Components/Assets/ModernFurniture.mp4';
import { getApiBaseUrl } from '../config';

const products = [
  { id: 1, image: product1, alt: 'Chair' },
  { id: 2, image: product2, alt: 'Table' },
  { id: 3, image: product3, alt: 'Lamp' },
  { id: 4, image: product4, alt: 'Sofa' },
  { id: 5, image: product5, alt: 'Bookshelf' },
];

const LandingPage = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [products, setProducts] = useState([]); // State to hold fetched products
  const [loading, setLoading] = useState(true); // Loading state to show loading spinner or message
  const [error, setError] = useState(null); // Error state to handle any fetch errors

  // Fetch the latest products when the component mounts
  useEffect(() => {
    const fetchNewProducts = async () => {
      try {
        const response = await fetch(`${getApiBaseUrl()}/newcollections`); // Update the API endpoint as needed
        const data = await response.json();
        setProducts(data); // Update products state with the response data
      } catch (err) {
        setError('Failed to load new products'); // Handle errors
        console.error('Error fetching products:', err);
      } finally {
        setLoading(false); // Set loading to false when done
      }
    };

    fetchNewProducts();
  }, []);

  const handleNext = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 2) % products.length); 
  };

  const handlePrev = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex - 2 < 0 ? products.length - 2 : prevIndex - 2
    );
  };

  const displayedProducts = products.slice(currentIndex, currentIndex + 2);

  return (
    <div>
      <header className="hero-section">
        <video
          className="hero-video"
          autoPlay
          loop
          muted
          playsInline
          poster="/assets/video-thumbnail.jpg" // Optional: Poster image before the video loads
        >
          <source src={HomeVideo} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
        
        <div className="content">
          <img src={Logo} alt="Ruby & Red Logo" className="logo" />
          <p>Where Fun Meets Function - Bold, Chic Furniture for Every Home</p>
          <button className="hero-btn">Show More</button>
        </div>
      </header>

      <section className="new-this-week">
        <h2>NEW THIS WEEK</h2>
        <p>Check out this week's arrivals</p>

        {loading ? (
          <div className="spinner-modal">
            <div className="spinner-container">
              <div className="loading-spinner"></div>
              <p className="spinner-text">Loading products...</p>
              </div>
            </div> 
        ) : error ? (
          <p>{error}</p> // Show error message if API fetch fails
        ) : (
          <div className="product-carousel">
            <button onClick={handlePrev} className="arrow-btn left-arrow">
              &#10094;
            </button>

            <div className="items">
              {displayedProducts.map((product) => (
                <img key={product._id} src={product.images[0]} alt={product.name} /> // Use the first image from the product
              ))}
            </div>

            <button onClick={handleNext} className="arrow-btn right-arrow">
              &#10095;
            </button>
          </div>
        )}
      </section>

      <section className="explore">
        <h2>EXPLORE</h2>
        <p>Explore, get inspired, and bring your space to life.</p>
        <div className="grid">
          <ExploreContent />
        </div>
      </section>

      <footer className="footer">
        {/* Existing footer section here */}
      </footer>
    </div>
  );
};

export default LandingPage;
